export const backendBaseUrl = "https://vfi.remidio.com";
export const apiToken =
  "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiIzMThmNDVjOC00OTU0LTRjZGYtYTVhOS1iYmU3YWYxMDQyYTYiLCJpc3MiOiJodHRwczovL2RpY29tLXNlY3VyZS1zdGFnaW5nLmFwcHNwb3QuY29tIiwic3ViIjoiNTYzMjQ5OTA4MjMzMDExMiIsImlhdCI6MTU3OTQ1Mjg4N30.KaLV2fMhhgtQq2x_caICqkV3aqwNBtEohOuxglBi7wU";
